module.exports = __webpack_public_path__ + "img/icon_linkedin.c9dd3e1663b197c6a92f5c958c743923.svg";